import { render, staticRenderFns } from "./IframeTest.vue?vue&type=template&id=aa98ebb0&scoped=true"
import script from "./IframeTest.vue?vue&type=script&lang=js"
export * from "./IframeTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa98ebb0",
  null
  
)

export default component.exports